import { Col as ReactstrapCol, Container as ReactstrapContainer, Row as ReactstrapRow } from 'reactstrap';
import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';

export const Container = styled(ReactstrapContainer)`
  padding: 0;
  background-color: ${props => props.theme.colors.white};

  ${props => props.theme.mediaQueries.small} {
    background-color: ${props => props.theme.colors.capsuleGreen00};
  }
`;

export const Row = styled(ReactstrapRow)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
`;

export const Col = styled(ReactstrapCol)`
  display: flex;
  align-items: center;
  padding: 0 0 ${props => props.theme.space.s5} 0;

  border-left-width: ${props => (props.borderLeft ? '1px' : 'initial')};
  border-left-style: ${props => (props.borderLeft ? 'solid' : 'none')};
  border-left-color: ${props => (props.borderLeft ? props.theme.colors.capsuleGray10 : 'initial')};

  border-right-width: ${props => (props.borderRight ? '1px' : 'initial')};
  border-right-style: ${props => (props.borderRight ? 'solid' : 'none')};
  border-right-color: ${props => (props.borderRight ? props.theme.colors.capsuleGray10 : 'initial')};

  ${props => props.theme.mediaQueries.small} {
    padding: ${props => props.theme.space.s5} 0;
  }

  ${props => props.theme.mediaQueries.smallDown} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Border = styled.div`
  ${props => props.theme.mediaQueries.smallDown} {
    display: none;
  }

  opacity: 0.24;
  height: 8.8rem;
  width: 0.1rem;

  /*
  * The following hardcoded color is required by the design for the ZipcodeChecker and not a standard Capsule color.
  */
  background-color: #74a6a2;

  ${props => props.theme.mediaQueries.small} {
    margin-left: ${props => props.theme.space.s7};
  }

  /*
  * The hardcoded values for this media query were arrived at from QA.
  */
  @media screen and (min-width: 576px) and (max-width: 640px) {
    margin-left: ${props => props.theme.space['2.5']};
  }
`;

export const WaitListSpan = styled.span`
  color: ${props => props.theme.colors.capsuleGreen60};
  padding-bottom: 0.2rem;
  border-bottom: 1.5px solid ${props => props.theme.colors.capsuleGreen60};
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  margin-top: 0.4rem;

  ${props => props.theme.mediaQueries.small} {
    padding-left: ${props => props.theme.space.s7};
  }

  /*
  * The hardcoded values for this media query were arrived at from QA.
  */
  @media screen and (min-width: 576px) and (max-width: 640px) {
    padding-left: ${props => props.theme.space['2.5']};
  }
`;

export const ZipWrapper = styled.div`
  position: relative;
  top: 0.6rem;
  width: 100%;

  ${props => props.theme.mediaQueries.smallDown} {
    width: calc(100% - 1.2rem);
  }

  ${props => props.theme.mediaQueries.small} {
    padding-left: ${props => props.theme.space.s7};
  }

  ${props => props.theme.mediaQueries.medium} {
    top: 0.2rem;
    padding-left: ${props => props.theme.space.s7};
  }

  /*
  * The hardcoded values for this media query were arrived at from QA.
  */
  @media screen and (min-width: 576px) and (max-width: 640px) {
    padding-left: ${props => props.theme.space['2.5']};
  }

  input {
    width: 100%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-shadow: 0 0 0 30px ${props => props.theme.colors.capsuleGreen00} inset !important;
  }
`;

export const StyledButton = styled(Button)`
  line-height: 0.4 !important;
  height: 3.2rem;
  background-color: transparent;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.radii.small};

  ${props => props.theme.mediaQueries.smallDown} {
    width: 100%;
  }

  ${props => props.theme.mediaQueries.small} {
    background-color: ${props => props.theme.colors.capsuleGreen00} !important;
  }

  /*
 * The hardcoded values for this media query were arrived at from QA.
 */
  @media screen and (min-width: 576px) and (max-width: 640px) {
    padding-left: ${props => props.theme.space.s3};
    padding-right: ${props => props.theme.space['2.5']};
  }
`;

export const ButtonText = styled.div`
  padding-bottom: ${props => props.theme.space['0.2']};
`;

export const ButtonContainer = styled.div`
  ${props => props.theme.mediaQueries.smallDown} {
    width: 100%;
  }

  ${props => props.theme.mediaQueries.small} {
    padding-left: ${props => props.theme.space.s7};
    padding-right: ${props => props.theme.space.s7};
  }

  /*
  * The hardcoded values for this media query were arrived at from QA.
  */
  @media screen and (min-width: 576px) and (max-width: 640px) {
    padding-left: ${props => props.theme.space.s3};
    padding-right: ${props => props.theme.space['2.5']};
  }
`;
